import { Mui, MuiIcons } from "@osu/react-ui";


const FORCED_AUTHENTICATION = import.meta.env.VITE_FORCED_AUTHENTICATION === "true";
const OSU_NAV_ID = "osu-navbar";
const NAVBAR_WRAPPER_ID = "admissions-header";
const MAIN_ID = "page-content";
const ACCESSIBLE_REFLOW_HEIGHT = `399px`;
const TOC_WIDTH = `15rem`;

const COMMITTEE_TRAINING = {
    id: "training",
    name: "Training",
};

const COMMITTEE_COLOR_MAP = {
  "athlete": "#00CCFF",
  "domestic-freshman": "#40E0D0",
  "international-freshman": "#CCCCFF",
  "domestic-transfer": "#99CC66",
  "international-transfer": "#FFCCFF",
  "military": "#FFCCCC",
  "non-traditional": "#FFCC00",
  "ccp-metro-hs": "#FFB36B",
  "ccp-academy": "#FF9999",
  "ccp-academy-regional": "#a832a2",
  "ohio-state-online": "#2f6735ff",
};

const RESIDENCY_MAP = {
  "A": "Special Visa in State",
  "B": "Special Visa Conditional",
  "C": "Conditional Resident",
  "I": "International",
  "N": "Non-Ohio Resident",
  "Q": "C-3 Instant",
  "R": "Ohio Resident",
}
const AUTH_TYPES = {
  ADMIN: "ADMIN",
  READER: "READER", // todo: remove reader
  REVIEWER: "REVIEWER",
  UNAUTHORIZED: "UNAUTHORIZED",
  ADMIN_REVIEWER: "ADMIN_REVIEWER"
}

const STATUSES = {
   RESUMELATER: "RESUMELATER",
   ASSIGNED: "ASSIGNED",
   NOTIFY: "NOTIFY",
   CANCELLED: "CANCELLED",
}

const REVIEW_NOTES_MAP = {
  COMPETITIVE: {
    KEY: "COMPETITIVE",
    LABEL: "Competitive Notes",
    DESCRIPTION: "",
  },
  NONCOMPETITIVE: {
    KEY: "NONCOMPETITIVE",
    LABEL: "Noncompetitive Notes",
    DESCRIPTION: "",
  },
  DOCUMENT: { KEY: "DOCUMENT", LABEL: "Document Notes", DESCRIPTION: "" },
  EVALUATION: { KEY: "EVALUATION", LABEL: "Evaluation Notes", DESCRIPTION: "" },
  OTHERCONCERNS: {
    KEY: "OTHERCONCERNS",
    LABEL: "Other Notes/Concerns",
    DESCRIPTION: "",
  },
};

const APPLICATION_TYPES = {
  TRAINING: 'TRAINING',
}

const RECOMMENDATION_HISTORY_UPDATES = {
  ASSIGN: 'ASSIGN',
  UNASSIGN: 'UNASSIGN'
}

const STATUS = {
    ASSIGNED: "ASSIGNED",
    RESUMELATER: "RESUMELATER",
    LOADING: "LOADING",
    ERROR: "ERROR",
    SUCCESS: "SUCCESS",
    CANCEL: "CANCEL",
    CANCELLED: "CANCELLED",
    CURRENT: 'CURRENT',
    ACTIVE: 'ACTIVE',
    INACTIVE: "INACTIVE",
    UPDATE_SUCCESSFUL: 'UPDATE_SUCCESSFUL',
    INPROGRESS: 'INPROGRESS',
    ADMINREVIEW: 'ADMINREVIEW',
    PENDINGAPPROVAL: 'PENDINGAPPROVAL',
    COMPLETE: 'COMPLETE',
    SUBMITTED: 'SUBMITTED',
    CLEAR: 'CLEAR',
    REFETCH: 'REFETCH',
    success: "success",
    partial_failure: "partial_failure",
}

const STATUS_BOOLEAN = {
  YES: 'Yes',
  NO: 'No',
}

const SEVERITY_LEVELS = {
  INFO: 'INFO',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
}

const ERROR_CONSTS = {
  UI: {
    GENERIC: {
      EMPTY_ALERT: {
        MESSAGE: '',
        SEVERITY: null,
      },
      SELECT_REVIEWER_EMPTY: {
        MESSAGE: 'Please select an option before submitting.',
        SEVERITY: SEVERITY_LEVELS.WARNING,
      },
      SELECT_COMPLETEDBYDATE_EMPTY: {
        MESSAGE: 'Please select a valid date before submitting.',
        SEVERITY: SEVERITY_LEVELS.WARNING,
      },
      NOTIFY_EMPTY: {
        MESSAGE: 'Please choose at least one option before submitting.',
        SEVERITY: SEVERITY_LEVELS.WARNING,
      },
    },
  },
};

const ALERT_MESSAGES = {
  ERROR_RETRIEVING_APPLICATION:
    'Error retrieving application.',
  ERROR_RETRIEVING_REPORT:
    'Error retrieving report.',
  ERROR_RETRIEVING_DOCUMENTS:
    'Error retrieving documents.',
  ERROR_RETRIEVING_DOCUMENT:
    'Error retrieving document.',
  ERROR_RETRIEVING_SEARCH_RESULTS:
    'Applicant does not exist or error retrieving search results.',
  ERROR_RETRIEVING_COMMITTEES:
    'Error retrieving committees.',
  ERROR_RETRIEVING_COMMITTEE_REVIEWERS:
    'Error retrieving committee reviewers.',
  ERROR_OVERRIDING_APPLICATION:
    'Error overriding application.',
  ERROR_UPDATE:
    'Error updating records.',
  SUCCESS_UPDATE:
    'Updated successfully.',
  ERROR_UPDATING_USER_INPUTS:
    'Error updating the selected fields.',
  SUCCESS_UPDATING_USER_INPUTS:
    'Success updating the selected fields.',
  SUCCESS_OVERRIDING_APPLICATION:
    'Recommendation successfully submitted.',
  };

const RECOMMENDATIONS = {
    ADMIT_WITH_RESTRICTION: "Admit with Restriction", // Only need to validate against this for now (AFAIK)
};

const NOTES_KEYS = {
    RESTRICTIONS: "restrictions",
};

const DOCUMENTTYPE_TO_KEYWORDNAMES = {
    "ADM Application": [],
    "ADM High School Document": ["High School Document Type"],
    "ADM Correspondence": ["Correspondence Type"],
    "ADM University Document": ["University Document Type"],
};

const SEARCH = {
  VIEW: 'View Only',
  APPLICANT: 'Applicant',
  APPLICATION: 'Application',
  REVIEWER: 'Reviewer',
  SEARCH: 'Search',
  TRAINING: 'Training',
  TRAINING_APPLICATION: 'Training Application'
}

const TOOLTIPS = (type, data) => {
  const iconStyles = {
    margin: '.1rem 0 0 .3rem'
  }

  switch(type){
    case "ASSIGNED":
      return (
        <Mui.Tooltip title={"This application has been manually assigned."} placement="right">
          <MuiIcons.AssignmentLate fontSize="small" style={{ color: '#ffbe45', ...iconStyles }} />
        </Mui.Tooltip>
        )
    case "PRIORITY":
      return (
        <Mui.Tooltip title={"This application has been marked as a priority."} placement="right">
          <MuiIcons.AssignmentLate fontSize="small" color='primary' style={{...iconStyles}} />
        </Mui.Tooltip>
        )
    case "RESUMELATER":
      return (
        <Mui.Tooltip title={"This application has been saved for later."} placement="right">
          <MuiIcons.Bookmark fontSize="small" style={{ color: '#639ed6', ...iconStyles }} />
        </Mui.Tooltip>
        )
    case "NOTIFY":
      return (
        <Mui.Tooltip title={"This application has been flagged for review."} placement="right">
          <MuiIcons.ReportProblem fontSize="small" style={{ color: '#a8224a', ...iconStyles }} />
        </Mui.Tooltip>
        )
    case "NOTIFY_CLEARED":
      return (
        <Mui.Tooltip title={"Returned by Admin."} placement="right">
          <MuiIcons.Check fontSize="small" style={{ color: '#639ed6', ...iconStyles }} />
        </Mui.Tooltip>
        )
    case "TRAINING":
    return (
      <Mui.Tooltip title={"This application has been cloned for training."} placement="right">
        <MuiIcons.School fontSize="small" style={{ color: '#ffbe45', ...iconStyles }} />
      </Mui.Tooltip>
      )
    case "PASTDUE":
      return (
        <Mui.Tooltip title={"This application is past due."} placement="right">
          <MuiIcons.AccessAlarm fontSize="small" style={{ color: '#f72d05', ...iconStyles }} />
        </Mui.Tooltip>
        )
    case "HOLD_FOR_ADMIN":
      return (
        <Mui.Tooltip title={`Held since ${data}`} placement="right">
          <MuiIcons.Policy fontSize="small" style={{ color: '#a8224a', ...iconStyles }} />
        </Mui.Tooltip>
        )
    default:
      return null
    }
  }

const ADMIN_REVIEW_COMMITTEE_LIST = [
  { id: "athlete", adminReview: false },
  { id: "ccp-academy", adminReview: true },
  { id: "ccp-academy-regional", adminReview: true },
  { id: "ccp-metro-hs", adminReview: true },
  { id: "domestic-freshman", adminReview: false },
  { id: "domestic-transfer", adminReview: true },
  { id: "international-freshman", adminReview: false },
  { id: "international-transfer", adminReview: true },
  { id: "military", adminReview: true },
  { id: "non-traditional", adminReview: true },
  { id: "ohio-state-online", adminReview: true },
];

/**
 * Known report types whose column definitions are fetched to build the
 * advanced-search field registry.  Excludes pastdue and training because
 * their columns are reviewer-centric (readerEmployeeId, readerLastName, etc.).
 * Excludes notifyadmin because its unique fields (lastNotifiedDate, reviewers,
 * notes fields) live on ApplicationNotifyAdmin records, not Application records,
 * and advanced search queries filter to type=Application only.
 */
const ADVANCED_SEARCH_REPORT_TYPES = [
  { key: 'search', label: 'Search' },
  { key: 'pending', label: 'Pending' },
  { key: 'complete', label: 'Complete' },
  { key: 'recommendations', label: 'Recommendations' },
  { key: 'adminreviews', label: 'Admin Reviews' },
];

const REPORT_SELECTION_MODES = { ALL: "all", INDIVIDUAL: "individual" };

/**
 * Maps reportType identifiers to their corresponding route paths.
 * Used to construct the `?from=` query parameter when opening applicant
 * detail pages in new tabs, enabling the "Reports" back-navigation link.
 */
const REPORT_TYPE_TO_ROUTE = {
  manageapplications: 'manage-applications',
  recommendations: 'reports/recommendations',
  notifyadmin: 'reports/notifyadmin',
  adminreviews: 'reports/adminreviews',
  requestadditionalinformation: 'reports/requestadditionalinformation',
  complete: 'reports/complete',
  training: 'reports/training',
  pending: 'reports/inreview',
  pastdue: 'reports/pastdue',
};

/** Default page size for paginated data grids */
const DATA_GRID_PAGE_SIZE = 10;

/** Preset rows-per-page dropdown options (increments of 10 up to 100, matching prod) */
const DATA_GRID_PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

/**
 * Maximum rows-per-page for the MUI X community DataGrid, which throws above 100.
 * Used as a LOCAL guard by the DataGrid-based grids (Manage Reviewers, Custom
 * Reports) to clamp the shared rows-per-page value. MRT grids are not capped and
 * support arbitrary custom page sizes.
 */
const DATA_GRID_MAX_PAGE_SIZE = 100;

/** Maximum number of unique filter options before falling back to text input */
const DATA_GRID_MAX_FILTER_OPTIONS = 50;

/** Duration (ms) to show the data freshness toast after mutations */
const DATA_GRID_FRESHNESS_TOAST_DURATION = 10000;

export {
  ACCESSIBLE_REFLOW_HEIGHT,
  ADMIN_REVIEW_COMMITTEE_LIST,
  ADVANCED_SEARCH_REPORT_TYPES,
  ALERT_MESSAGES,
  APPLICATION_TYPES,
  AUTH_TYPES,
  COMMITTEE_COLOR_MAP,
  COMMITTEE_TRAINING,
  DATA_GRID_FRESHNESS_TOAST_DURATION,
  DATA_GRID_MAX_FILTER_OPTIONS,
  DATA_GRID_MAX_PAGE_SIZE,
  DATA_GRID_PAGE_SIZE,
  DATA_GRID_PAGE_SIZE_OPTIONS,
  DOCUMENTTYPE_TO_KEYWORDNAMES,
  ERROR_CONSTS,
  FORCED_AUTHENTICATION,
  MAIN_ID,
  NAVBAR_WRAPPER_ID,
  NOTES_KEYS,
  OSU_NAV_ID,
  RECOMMENDATIONS,
  RECOMMENDATION_HISTORY_UPDATES,
  REPORT_SELECTION_MODES,
  REPORT_TYPE_TO_ROUTE,
  RESIDENCY_MAP,
  REVIEW_NOTES_MAP,
  SEARCH,
  SEVERITY_LEVELS,
  STATUS,
  STATUSES,
  STATUS_BOOLEAN,
  TOC_WIDTH,
  TOOLTIPS,
};
